import { Button, Divider, message,Spin } from "antd";
import Typography from "antd/es/typography/Typography";
import IconSuccess  from "../../PayHostingFee/HostingFeeOrderDetails/success-icon.svg";
// import PhoneIcon from "../../PayHostingFee/HostingFeeOrderDetails/phone.svg";
// import EmailIcon from "../../PayHostingFee/HostingFeeOrderDetails/email.svg";
// import ArrowRight from "../../PayHostingFee/HostingFeeOrderDetails/arrow-right.svg";
import BG from "../../PayHostingFee/HostingFeeOrderDetails/order-bg.svg";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useNavigate, useParams } from "react-router-dom";
import api from "../../../../api/api";
import React,{ useEffect, useState } from "react";
import moment from "moment";
import { IconFails } from "../../../../assets/icons";


const NotiDetails = ({ data }) => {

  const [notiDetails, setNotiDetails] = useState({});
  const [dataLoaded, setDataLoaded] = React.useState(false);
  const [loading, setLoading] = useState(true);

  

  const { id } = useParams();


  const navigate = useNavigate();

  const handleBackRoute = () => {
    navigate("/home/notifications");
  }


    // const getNotificationDetails = (id) => {
    //   api
    //     .getNotificationDetails(id)
    //     .then((data) => {
    //       setNotiDetails(data);
    //     })
    //     .catch((error) => {
    //       message.error(error);
    //     });
    // };

     const getNotificationDetails = async (id) => {
    try {
      const res = await api.getNotificationDetails(id);
      setNotiDetails(res);
    } catch (error) {
      message.error("Failed to load notification details");
    } finally {
      setLoading(false);
    }
  };


      useEffect(() => {
        Promise.all([
         getNotificationDetails(id)
        ]).finally(() => setDataLoaded(true));
        // eslint-disable-next-line
      }, []);

const handlePhoneClick = () => {
  const phoneNumbers = notiDetails?.data?.contact?.phone_numbers;
  if (phoneNumbers?.length > 0) {
    window.location.href = `tel:${phoneNumbers[0]}`;
  }
};

const handleEmailClick = () => {
  const email = notiDetails?.data?.contact?.email;
  if (email) {
    window.location.href = `mailto:${email}`;
  }
};

if (loading) {
    return (
      <div
        style={{
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "#f7f8fb",
        }}
      >
        <Spin size="large" tip="Loading notification details..." />
      </div>
    );
  }

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: "40px 16px",
        backgroundCIconSuccessolor: "#F7F8FB",
        minHeight: "100vh",
      }}
    >
      <div onClick={handleBackRoute} style={{display:"flex",cursor:"pointer",alignItems:"center",gap:"20px",marginBottom:"30px",justifyContent:"start",width:"780px"}}>
        <div style={{border:"1px solid #EAEAEA",borderRadius:"8px",width:"40px",height:"40px",display:"flex", justifyContent:"center", alignItems:"center"}}>
         {/* <img /> */}
         <ArrowLeftOutlined/>
        </div>
        <p style={{fontSize:"24px",color:"#1A1A1A",fontWeight:700,}}>Notification Details</p>
      </div>
      <div
        style={{
          width: "100%",
          maxWidth: 780,
          backgroundColor: "#fff",
          borderRadius: 16,
          overflow: "hidden",
          borderTopLeftRadius:"24px",
          borderTopRightRadius:"24px",
          position:"relative",
        }}
      >
        {/* Top Section - Blue Header */}
        <div
          style={{
            backgroundColor: "#1859FF",
            padding: 26,
            color: "white",
            width:"100%",
            minHeight:"240px",
            display:"flex",
            justifyContent:"center",
            alignItems:"start",
          }}
        >
         
          <div style={{display:"flex",flexDirection:"column",gap:"0px",alignItems:"start",padding:"0px 20px",zIndex:"99",textAlign:"left",width:"100%"}}>
          <div style={{ display: "flex", alignItems: "center", gap: 3 }}>
            {(notiDetails?.data?.payment_status === "Failed" || notiDetails?.data?.payment_status === "Overdue" )? 
             <IconFails/>
              :
             <img src={IconSuccess} alt="success-icon" style={{width:"35px",height:"35px"}}/>
            }
            <Typography style={{ fontSize: 24, fontWeight: "bold", color: "#fff" }}>
              {notiDetails?.data?.payment_status === "Failed" ? "Payment Failed!" : 
              notiDetails?.data?.payment_status === "Success" ? "Payment Successful!" :
              notiDetails?.data?.payment_status} 
            </Typography>
          </div>
          <Typography style={{ marginTop: 8, fontSize: 14, color: "#fff",padding:"5px 20px" }}>
            
           {notiDetails?.data ? (
                <div
                    dangerouslySetInnerHTML={{ __html: notiDetails.data.body }}
                />
                ) : (
                ""
                )}
          </Typography>
        </div>
         <img src={BG} alt="order-bg"  style={{
            position:"absolute",
            top:0,
            right:0,
            left:0,
            bottom:0,
            background:"contain",
            // zIndex:"-1",
            width:"95%",
            height:"auto"
          }} />
        </div>
        <div style={{backgroundColor:"#fff",borderTopRightRadius:"24px",borderTopLeftRadius:"24px",marginTop:"-80px",zIndex:"99999 !important"}}>
        {/* White Body Section */}
        <div style={{ padding: 32, display: "flex", flexDirection: "column", gap: 24 }}>
          {/* Order Details */}
          <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
            <Typography style={{ fontWeight: "bold" }}>
                {notiDetails?.data?.notification_type === "SERVER_FAILED_PAYMENT" ? "Order Details" :
                notiDetails?.data?.notification_type === "MAINTAIN_BILLING_ALERT" ? "Store Details" :
                notiDetails?.data?.notification_type === "MAINTAIN_FAILED_PAYMENT" ? "Order Details" :
                notiDetails?.data?.notification_type === "MAINTAIN_SUCCESS_PAYMENT" ? "Order Details" :
                notiDetails?.data?.notification_type === "MAINTAIN_OVERDUE_PAYMENT" ? "Order Details" :
                notiDetails?.data?.notification_type === "HOSTING_BILLING_ALERT" ? "Store Details" :
                notiDetails?.data?.notification_type === "HOSTING_FAILED_PAYMENT" ? "Order Details" :
                ""}
                </Typography>
           {/* SERVER_FAILED_PAYMENT */}
           {notiDetails?.data?.notification_type === "SERVER_FAILED_PAYMENT" && 
            [
              { label: "Date", value: moment(notiDetails?.data?.created_at).format("DD MMM YYYY")  },
              { label: "Type", value: notiDetails?.data?.type === "SERVER_FEE" ? "Server Fee" : "-" },
              { label: "Store name", value: notiDetails?.data?.store?.name },
              { label: "Billing Period",
                 value: `${moment(notiDetails?.data?.billing_period?.start_date).format("DD MMM YYYY")} 
                 - ${moment(notiDetails?.data?.billing_period?.end_date).format("DD MMM YYYY")}`},
            ].map((item, i) => (
              <div
                key={i}
                style={{ display: "flex", justifyContent: "space-between", fontSize: 14 }}
              >
                <Typography>{item.label}</Typography>
                <Typography>{item.value}</Typography>
              </div>
            ))
            }
            {/* MAINTAIN_BILLING_ALERT */}
           {notiDetails?.data?.notification_type === "MAINTAIN_BILLING_ALERT" && 
            [
              { label: "Type", value: notiDetails?.data?.type === "MAINTAIN_FEE" ? "Maintain Fee" : "-" },
              { label: "Template Name", value: notiDetails?.data?.template?.template_name?.en},
              { label: "Template ID", value: notiDetails?.data?.template?.template_code},
              { label: "Store name", value: notiDetails?.data?.store?.name },
              { label: "Store Domain", value: notiDetails?.data?.store?.domainRecords[0]?.domain_name },
            ].map((item, i) => (
              <div
                key={i}
                style={{ display: "flex", justifyContent: "space-between", fontSize: 14 }}
              >
                <Typography>{item.label}</Typography>
                <Typography>{item.value}</Typography>
              </div>
            ))
            }
            {/* MAINTAIN_FAILED_PAYMENT */}
           {notiDetails?.data?.notification_type === "MAINTAIN_FAILED_PAYMENT" && 
            [
             { label: "Date", value: moment(notiDetails?.data?.date).format("DD MMM YYYY") },
              { label: "Type", value: notiDetails?.data?.type === "MAINTAIN_FEE" ? "Maintain Fee" : "-" },
              { label: "Template Name", value: notiDetails?.data?.template?.template_name?.en},
              { label: "Template ID", value: notiDetails?.data?.template?.template_code},
              { label: "Store name", value: notiDetails?.data?.store?.name },
            ].map((item, i) => (
              <div
                key={i}
                style={{ display: "flex", justifyContent: "space-between", fontSize: 14 }}
              >
                <Typography>{item.label}</Typography>
                <Typography>{item.value}</Typography>
              </div>
            ))
            }
            {/* MAINTAIN_SUCCESS_PAYMENT */}
            {notiDetails?.data?.notification_type === "MAINTAIN_SUCCESS_PAYMENT" && 
            [
             { label: "Invoice Number", value: notiDetails?.data?.invoice_no ?? "-"},
             { label: "Date", value: moment(notiDetails?.data?.date).format("DD MMM YYYY") },
              { label: "Type", value: notiDetails?.data?.type === "MAINTAIN_FEE" ? "Maintain Fee" : "-" },
              { label: "Template Name", value: notiDetails?.data?.template?.template_name?.en},
              { label: "Template ID", value: notiDetails?.data?.template?.template_code},
              { label: "Store name", value: notiDetails?.data?.store?.name },
              { label: "Store Domain", value: notiDetails?.data?.store?.domainRecords[0]?.domain_name },
            ].map((item, i) => (
              <div
                key={i}
                style={{ display: "flex", justifyContent: "space-between", fontSize: 14 }}
              >
                <Typography>{item.label}</Typography>
                <Typography>{item.value}</Typography>
              </div>
            ))
            }
             {/* MAINTAIN_OVERDUE_PAYMENT */}
           {notiDetails?.data?.notification_type === "MAINTAIN_OVERDUE_PAYMENT" && 
            [
             { label: "Date", value: moment(notiDetails?.data?.date).format("DD MMM YYYY") },
              { label: "Type", value: notiDetails?.data?.type === "MAINTAIN_FEE" ? "Maintain Fee" : "-" },
              { label: "Template Name", value: notiDetails?.data?.template?.template_name?.en},
              { label: "Template ID", value: notiDetails?.data?.template?.template_code},
              { label: "Store name", value: notiDetails?.data?.store?.name },
            ].map((item, i) => (
              <div
                key={i}
                style={{ display: "flex", justifyContent: "space-between", fontSize: 14 }}
              >
                <Typography>{item.label}</Typography>
                <Typography>{item.value}</Typography>
              </div>
            ))
            }
             {/* HOSTING_BILLING_ALERT */}
           {notiDetails?.data?.notification_type === "HOSTING_BILLING_ALERT" && 
            [
              { label: "Type", value: notiDetails?.data?.type === "HOSTING_FEE" ? "Hosting Fee" : "-" },
              { label: "Template Name", value: notiDetails?.data?.template?.template_name?.en},
              { label: "Template ID", value: notiDetails?.data?.template?.template_code},
              { label: "Store name", value: notiDetails?.data?.store?.name },
              { label: "Store Domain", value: notiDetails?.data?.store?.domainRecords[0]?.domain_name },
            ].map((item, i) => (
              <div
                key={i}
                style={{ display: "flex", justifyContent: "space-between", fontSize: 14 }}
              >
                <Typography>{item.label}</Typography>
                <Typography>{item.value}</Typography>
              </div>
            ))
            }
             {/* HOSTING_FAILED_PAYMENT */}
           {notiDetails?.data?.notification_type === "HOSTING_FAILED_PAYMENT" && 
            [
             { label: "Date", value: moment(notiDetails?.data?.date).format("DD MMM YYYY") },
              { label: "Type", value: notiDetails?.data?.type === "HOSTING_FEE" ? "Hosting Fee" : "-" },
              { label: "Template Name", value: notiDetails?.data?.template?.template_name?.en},
              { label: "Template ID", value: notiDetails?.data?.template?.template_code},
              { label: "Store name", value: notiDetails?.data?.store?.name },
            ].map((item, i) => (
              <div
                key={i}
                style={{ display: "flex", justifyContent: "space-between", fontSize: 14 }}
              >
                <Typography>{item.label}</Typography>
                <Typography>{item.value}</Typography>
              </div>
            ))
            }
          </div>
          {/* Payment Details */}
          <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
             <Divider />
            <Typography style={{ fontWeight: "bold" }}>Payment Details</Typography>
            {/* SERVER_FAILED_PAYMENT */}
            {notiDetails?.data?.notification_type === "SERVER_FAILED_PAYMENT" && 
            [
            { label: "Pay with", value: notiDetails?.data?.payment_method},
            { label: "Payment status", value: notiDetails?.data?.status === "SUCCESS" ? "Successful" : "Failed"},
            { label: "Server Fee", value: `$${notiDetails?.data?.server_fee}` },
            { label: "Tax", value: `$${notiDetails?.data?.tax}` },
            { label: "Sub total", value: `$${notiDetails?.data?.subtotal}` },
          ].map((item, i) => (
            <div key={i}>
              {item?.label === "Sub total" && <Divider />}
              <div
                style={{ display: "flex", justifyContent: "space-between", fontSize: 14 }}
              >
                <Typography>{item.label}</Typography>
                <Typography>{item.value}</Typography>
              </div>
              {item?.label === "Sub total" && <Divider />}
            </div>
          ))}
           {/* MAINTAIN_BILLING_ALERT */}
          {notiDetails?.data?.notification_type === "MAINTAIN_BILLING_ALERT" && 
            [
            { label: "Payment Period",
                 value: `${moment(notiDetails?.data?.billing_period?.start_date).format("DD MMM YYYY")} 
                 - ${moment(notiDetails?.data?.billing_period?.end_date).format("DD MMM YYYY")}`},
            { label: "Pay with", value: notiDetails?.data?.payment_method},
            { label: "Payment status", value: notiDetails?.data?.payment_status},
            { label: "Maintain Fee", value: `$${notiDetails?.data?.maintain_fee}` },
            { label: "Sub total", value: `$${notiDetails?.data?.subtotal}` },
          ].map((item, i) => (
            <div key={i}>
              {item?.label === "Sub total" && <Divider />}
              <div
                style={{ display: "flex", justifyContent: "space-between", fontSize: 14 }}
              >
                <Typography>{item.label}</Typography>
                <Typography>{item.value}</Typography>
              </div>
              {item?.label === "Sub total" && <Divider />}
            </div>
          ))}
          {/* MAINTAIN_FAILED_PAYMENT */}
          {notiDetails?.data?.notification_type === "MAINTAIN_FAILED_PAYMENT" && 
            [
            { label: "Pay with", value: notiDetails?.data?.payment_method},
            { label: "Payment status", value: notiDetails?.data?.payment_status},
            { label: "Maintain Fee", value: `$${notiDetails?.data?.maintain_fee}` },
            { label: "Sub total", value: `$${notiDetails?.data?.subtotal}` },
          ].map((item, i) => (
            <div key={i}>
              {item?.label === "Sub total" && <Divider />}
              <div
                style={{ display: "flex", justifyContent: "space-between", fontSize: 14 }}
              >
                <Typography>{item.label}</Typography>
                <Typography>{item.value}</Typography>
              </div>
              {item?.label === "Sub total" && <Divider />}
            </div>
          ))}
          {/* MAINTAIN_SUCCESS_PAYMENT */}
          {notiDetails?.data?.notification_type === "MAINTAIN_SUCCESS_PAYMENT" && 
            [
            { label: "Pay with", value: notiDetails?.data?.payment_method},
            { label: "Payment status", value: notiDetails?.data?.payment_status},
            { label: "Maintain Fee", value: `$${notiDetails?.data?.maintain_fee}` },
            { label: "Sub total", value: `$${notiDetails?.data?.subtotal}` },
          ].map((item, i) => (
            <div key={i}>
              {item?.label === "Sub total" && <Divider />}
              <div
                style={{ display: "flex", justifyContent: "space-between", fontSize: 14 }}
              >
                <Typography>{item.label}</Typography>
                <Typography>{item.value}</Typography>
              </div>
              {item?.label === "Sub total" && <Divider />}
            </div>
          ))}
           {/* MAINTAIN_OVERDUE_PAYMENT */}
          {notiDetails?.data?.notification_type === "MAINTAIN_OVERDUE_PAYMENT" && 
            [
            { label: "Pay with", value: notiDetails?.data?.payment_method},
            { label: "Payment status", value: notiDetails?.data?.payment_status},
            { label: "Maintain Fee", value: `$${notiDetails?.data?.maintain_fee}` },
            { label: "Sub total", value: `$${notiDetails?.data?.subtotal}` },
          ].map((item, i) => (
            <div key={i}>
              {item?.label === "Sub total" && <Divider />}
              <div
                style={{ display: "flex", justifyContent: "space-between", fontSize: 14 }}
              >
                <Typography>{item.label}</Typography>
                <Typography>{item.value}</Typography>
              </div>
              {item?.label === "Sub total" && <Divider />}
            </div>
          ))}
           {/* HOSTING_BILLING_ALERT */}
          {notiDetails?.data?.notification_type === "HOSTING_BILLING_ALERT" && 
            [
            { label: "Payment Period",
                 value: `${moment(notiDetails?.data?.billing_period?.start_date).format("DD MMM YYYY")} 
                 - ${moment(notiDetails?.data?.billing_period?.end_date).format("DD MMM YYYY")}`},
            { label: "Pay with", value: notiDetails?.data?.payment_method},
            { label: "Payment status", value: notiDetails?.data?.payment_status},
            { label: "Hosting Fee", value: `$${notiDetails?.data?.hosting_fee}` },
            { label: "Sub total", value: `$${notiDetails?.data?.subtotal}` },
          ].map((item, i) => (
            <div key={i}>
              {item?.label === "Sub total" && <Divider />}
              <div
                style={{ display: "flex", justifyContent: "space-between", fontSize: 14 }}
              >
                <Typography>{item.label}</Typography>
                <Typography>{item.value}</Typography>
              </div>
              {item?.label === "Sub total" && <Divider />}
            </div>
          ))}
          {/* HOSTING_FAILED_PAYMENT */}
          {notiDetails?.data?.notification_type === "HOSTING_FAILED_PAYMENT" && 
            [
            { label: "Pay with", value: notiDetails?.data?.payment_method},
            { label: "Payment status", value: notiDetails?.data?.payment_status},
            { label: "Hosting Fee", value: `$${notiDetails?.data?.hosting_fee}` },
            { label: "Sub total", value: `$${notiDetails?.data?.subtotal}` },
          ].map((item, i) => (
            <div key={i}>
              {item?.label === "Sub total" && <Divider />}
              <div
                style={{ display: "flex", justifyContent: "space-between", fontSize: 14 }}
              >
                <Typography>{item.label}</Typography>
                <Typography>{item.value}</Typography>
              </div>
              {item?.label === "Sub total" && <Divider />}
            </div>
          ))}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                fontSize: 18,
                fontWeight: "400",
              }}
            >
              <Typography>Total</Typography>
              <Typography style={{fontSize:"24px",fontWeight:"500"}}>${notiDetails?.data?.subtotal}</Typography>
            </div>
          </div>

          <Button
            type="primary"
            style={{ height: 48, backgroundColor: "#1562FF", borderRadius: 6 }}
            block
            onClick={() => navigate("/home/notifications")}>
            Go Back
          </Button>

          {/* <Typography style={{ fontSize: 12, textAlign: "center" }}>
            Read One Site Cart <a href="#">Payment Policy</a> here.
          </Typography> */}
        </div>
        </div>
      </div>
      {/* Contact Us Section */}
    </div>
  );
};

export default NotiDetails;
